import Story from "./Story";

export default class Chapter {
    id:number = 1;
    name:string = "New Chapter";
    storys:Array<Story> = [new Story()];
}



// WEBPACK FOOTER //
// ./src/objects/Chapter.ts